import React from 'react';
import AdminDashboard from './admin-dashboard/AdminDashboard';
import SupplierDashboard from './supplier-dashboard/SupplierDashboard';
import { useSelector } from 'react-redux';

function Component() {
  const { user, role } = useSelector(({ user }) => user);
  return (
    <div>
      {role?.id !== 4 && <AdminDashboard />}
      {role?.id === 4 && <SupplierDashboard />}
    </div>
  );
}

export default Component;
